// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"5a93df0f","198":"700fed8a","227":"075273af","310":"cd989eed","488":"29b71886","713":"7065b087","735":"5353191f"}[chunkId] + ".chunk.js";
};